import React from 'react';
import styled from 'styled-components';
import { useWindowSize } from '../../hooks/useWindowSize';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { activateLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { getMyInfoRedirectUrl } from '../../redux/actions/my-info/my-info-action';
import { signPassToClevertap } from '../../utils/library';
import {
  KYC_METHOD_SELECTED,
  SING_PASS_KYC,
  FLOW_TYPE_ONBOARDING
} from '../../utils/constants/eventsConstants';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import { logEvent } from '../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../utils/events/eventsConstants';
import { FLOATING_LABEL_MY_INFO_ICON, MY_INFO_MOBILE_ICON } from '@Images';

const MyInfoContainer = styled.div`
  position: fixed;
  bottom: 0%;
  left: 40px;
  opacity: 1;
  cursor: pointer;
  margin-bottom: 40px;
  max-height: 50px;
  @media screen and (max-width: 600px) {
    bottom: 0%;
    left: 80%;
    border-radius: 50%;
    box-shadow: none;
    border: none;
  }
`;
const FlexRow = styled.div`
  display: flex;
  padding: 10px 30px 10px 20px;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    .label-container {
      padding: 40px;
      font-size: 7px;
    }
  }
  > img {
    width: 225px;
    margin-right: 13px;
    margin-top: -8px;
    margin-top: -8px;
    margin-top: -8px;
  }
  .label-container {
    display: flex;
    flex-direction: column;

    .heading {
      font-family: 'hellix-regular';
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: ${COLORS.textLightGrey};
    }
    .subheading {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.5;
      letter-spacing: 0.43px;
      text-align: center;
      color: ${COLORS.black};
      margin-top: -4px;
    }
  }
`;

export const MYInfoButton = (props) => {
  const { width = window.innerWidth } = useWindowSize();

  const handleSignPassLink = () => {
    signPassToClevertap(props.pageName);
    props.activateLoader();
    logEvent(
      KYC_METHOD_SELECTED,
      FLOW_TYPE_ONBOARDING,
      { kyc_type: SING_PASS_KYC },
      LOG_TYPE.CLEVER_TAP
    );
    props.getMyInfoRedirectUrl();
  };

  if (props.is_everification_attempted === false) {
    return (
      <>
        {width > 600 ? (
          <MyInfoContainer onClick={handleSignPassLink}>
            <FlexRow>
              <img src={FLOATING_LABEL_MY_INFO_ICON} alt="myInfo" width="100%" />
            </FlexRow>
          </MyInfoContainer>
        ) : (
          <MyInfoContainer onClick={handleSignPassLink}>
            <img style={{ height: '64px', width: '64px' }} src={MY_INFO_MOBILE_ICON} alt="myInfo" />
          </MyInfoContainer>
        )}
      </>
    );
  }
  return null;
};

MYInfoButton.propTypes = {
  is_everification_attempted: PropTypes.bool,
  activateLoader: PropTypes.func,
  getMyInfoRedirectUrl: PropTypes.func,
  pageName: PropTypes.string
};
const mapStateProps = (state) => {
  const {
    rootReducer: {
      userDataReducer: {
        userStateInfo: {
          remitterDetails: { is_everification_attempted }
        }
      }
    }
  } = state;
  return {
    is_everification_attempted
  };
};
export const MyInfoFloatingButton = connect(mapStateProps, {
  activateLoader,
  getMyInfoRedirectUrl
})(MYInfoButton);
